import { z } from "zod";
/**
 * Exercise Progress Schema for DynamoDB
 *
 * Progress is stored with denormalized info for efficient queries.
 *
 * PK: USER#<uid>
 * SK: PROGRESS#EXERCISE#<exerciseId>
 */
// Base ExerciseProgress schema for DynamoDB
// Matches server ProgressRepository.itemToExerciseProgress() output
export const ExerciseProgressSchema = z.object({
    user_uid: z.string(),
    exercise_id: z.number().int(),
    module_id: z.number().int(),
    course_id: z.number().int(),
    status: z.enum(["not_started", "in_progress", "completed"]),
    best_score: z.number().min(0).max(100).default(0),
    total_attempts: z.number().int().min(0).default(0),
    time_spent_seconds: z.number().int().min(0).default(0),
    last_attempt_at: z.date().nullable(),
    completed_at: z.date().nullable(),
});
// Payload schema for creating/updating exercise progress
export const ExerciseProgressPayloadSchema = z.object({
    exercise_id: z.number().int(),
    user_uid: z.string(),
    module_id: z.number().int(),
    course_id: z.number().int(),
});
// Schema for module exercise progress with exercise details (alias)
export const ModuleExerciseProgressSchema = ExerciseProgressSchema;
// Schema for exercise progress statistics
export const ExerciseProgressStatsSchema = z.object({
    total_users_started: z.number().int().min(0),
    total_users_completed: z.number().int().min(0),
    average_best_score: z.number().min(0).max(100),
    average_attempts_count: z.number().min(0),
    average_time_spent: z.number().min(0),
    completion_rate: z.number().min(0).max(100),
});
// Schema for exercise leaderboard entries
export const ExerciseLeaderboardEntrySchema = z.object({
    user_uid: z.string(),
    user_name: z.string().nullable(),
    best_score: z.number().min(0).max(100),
    total_attempts: z.number().int().min(0),
    time_spent_seconds: z.number().int().min(0),
    status: z.enum(["not_started", "in_progress", "completed"]),
    completed_at: z.date().nullable(),
});
// Schema for filters used in queries
export const ExerciseProgressFiltersSchema = z
    .record(z.string(), z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.date(),
    z.array(z.union([z.string(), z.number(), z.boolean()])),
]))
    .optional();
// Schema for attempt completion update parameters
export const AttemptCompletionSchema = z.object({
    userUid: z.string(),
    exerciseId: z.number().int(),
    attemptId: z.number().int(),
    score: z.number().min(0).max(100),
    timeSpentSeconds: z.number().int().min(0),
    isCorrect: z.boolean(),
});
